import React from 'react'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Link } from 'react-router-dom';
import ImageIcon from '@mui/icons-material/Image';
function Tablebody({tbody}) {
    var appData = {
        extensions: ['doc', 'docx', 'pdf', 'ppt', 'rtf', 'swf', 'txt', 'xls']
    };

    var imageData = {
        extensions: ['png', 'jpg', 'jpeg', 'jpg', 'gif', 'tiff', 'psd']
    };

    function isSpecialExtension(url, extensionsArray) {
        var extension = getExtensionFromUrl(url);
        if (extension === '') {
            return false;
        } else {
            if (extensionsArray.indexOf(extension) === -1) {
                return false;
            } else {
                return true;
            }
        }
    }

    function getExtensionFromUrl(url) {
        var extension = '';
        var pattern = /\.([0-9a-z]+)(?:[\?#]|$)/i;
        if (url.match(pattern) && url.match(pattern)[1]) {
            extension = url.match(pattern)[1];
        }
        return extension;
    }
    return (
        <tr>
          {tbody.map((item, index) => {
            return (
              <td key={index}>
                {isSpecialExtension(item, appData.extensions) ? (
                  <Link to={item} target="_blank" rel="noopener noreferrer" aria-label={`Open ${item.split('/').pop() || 'document'} - opens in new tab`}>
                    <PictureAsPdfIcon aria-hidden="true" />
                  </Link>
                ) : isSpecialExtension(item, imageData.extensions) ? (
                  <Link to={item} target="_blank" rel="noopener noreferrer" aria-label={`Open ${item.split('/').pop() || 'image'} - opens in new tab`}>
                    <ImageIcon aria-hidden="true" />
                  </Link>
                ) : (
                  <span>{item}</span>
                )}
              </td>
            );
          })}
        </tr>
    );
}

export default Tablebody
